export default __webpack_public_path__ + "static/media/potato4.905ce28e.png";